const INSPECTOR_MULTIPLE_ITEM_SELECTED = "<Multiple Items Selected>";

export { INSPECTOR_MULTIPLE_ITEM_SELECTED };
